var map = {
	"./broken_image.svg": 811,
	"./calendar.svg": 812,
	"./close.svg": 813,
	"./dehaze.svg": 814,
	"./delete.svg": 815,
	"./information.svg": 816,
	"./keyboard_arrow_down.svg": 817,
	"./keyboard_arrow_left.svg": 818,
	"./keyboard_arrow_right.svg": 819,
	"./keyboard_arrow_up.svg": 820,
	"./lock_outline.svg": 821,
	"./logout.svg": 822,
	"./person.svg": 823,
	"./selected.svg": 824,
	"./selected_invert.svg": 825,
	"./small_caret_down.svg": 826,
	"./small_caret_right.svg": 827,
	"./step_arrow.svg": 828,
	"./switch-off.svg": 829,
	"./switch-on.svg": 830,
	"./zoom_in.svg": 831
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 979;


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/svg nonrecursive \.svg$
// module id = 979
// module chunks = 0